module.exports = __webpack_public_path__ + "sideSprite-71c4774b147097d6f86e920f6e798f59.png";